export default "__VITE_ASSET__9c327a53__"